import {h, Fragment} from "preact"
import Product from './Product'
import { useAppState } from '@nosto/preact'

export default function Products() {
    const { response: { products } } = useAppState();

    return (
        <ul
            class="grid product-grid  grid--1-col-tablet-down grid--3-col-desktop"
            role="list"
        >
            {products.hits.map((hit, index) => (
                <Product 
                    key={hit.productId || index}
                    product={hit} 
                />
            ))}
        </ul>
    )
}
